import { base64DecodeBinary } from './base64.ts';

export { base64DecodeBinary };

export { base64EncodeBinary, base64Encode, base64Decode } from './base64.ts';

export {
  base32EncodeBinary,
  base32Encode,
  base32EncodeBinaryNoPadding,
  base32EncodeNoPadding,
  base32DecodeBinary,
  base32Decode,
} from './base32.ts';

export { jwtToBinary, binaryToJwt, encodeTokenForWebSocket } from './jwt.ts';

// data:[<media type>][;charset=<character set>][;base64],<data>
const dataUrlRegex =
  /^data:(?<mimeType>[\w/+-]*)(?:;charset=[\w-]+|;base64)?,(?<data>.*)/i;

/**
 * Decodes a data URL to a Blob.
 */
export const decodeDataUrl = (encoded: string): Blob | undefined => {
  const match = encoded.match(dataUrlRegex);
  if (match != null && match.groups?.mimeType != null && match.groups?.data != null) {
    return new Blob([base64DecodeBinary(match.groups.data)], {
      type: match.groups.mimeType,
    });
  }
};
